import { Component, OnInit, ElementRef, ViewChild } from '@angular/core'
import { NumericTextFieldValidator } from '../../../validations/numeric-text-field-validator'
import { LengthTextFieldValidator } from '../../../validations/length-text-field-validator'
import { OnList } from '../../models/enrollment-search-on'
import { ListStatus } from '../../models/list-status-model'
import { LeadType } from '../../models/lead-type-model'
import * as moment from 'moment'
import { SearchModel } from '../../models/enrollment-search-details'
import { ReportsGateway } from '../../gatewasys/reports.gateway'
import { EnrollmentSearch } from '../../models/EnrollmentSearch'
import { PortalGlobals } from '../../../../app/portalglobals'
import { EnrollmentViewModel } from '../../../enrollment/models/enrollment-view-model'
import { EnrollmentGateway } from '../../../enrollment/gateways/enrollment-gateway'
import { GetEnrollmentRequest } from '../../models/GetEnrollmentDataRequest'
import { GetEnrollmentDataByID } from '../../../enrollment/models/get-enrollment-data-response'
import { CurrentUser } from '../../../common/models/current-user'
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid'
import { UserGateway } from '../../../user-management/gateways/user-gateway'
import { ValidatedRadioButtonModel } from '../../../validations/validated-radio-button-group.component'
import { EnrollmentElectionType } from '../../../enrollment/models/enrollment-election-type'
import { IPadHistory } from '../../../enrollment/models/ipadhistory-model'
import { IPadPDF } from '../../../enrollment/models/ipadhistory-model'
import { PlanList } from '../../../enrollment/models/plan-list'
import * as _ from 'lodash'
import { ExcelService } from '../../excel.service'
import { UserAccessGateway } from '../../../common/gateways/user-access-gateway'
import { JqxGridVirtualPaging } from '../../../common/utilclasses/jqxgrid-virtualpaging'
@Component({
    providers: [],
    selector: 'SearchEnrollment',
    templateUrl: 'enrollment-search.component.html'
})
export class EnrollmentSearchComponent implements OnInit {
    numericTextFieldValidator = new NumericTextFieldValidator()
    lengthValidator = new LengthTextFieldValidator(9)
    OnList = []
    listStatus = []
    LeadTypes: Array<LeadType>
    statusList: Array<ListStatus>
    searchList: Array<OnList>
    fmoModelPortal: SearchModel
    fmoModelConsumer: SearchModel
    fmoModelIPad: SearchModel
    enrollmentSearchModel: EnrollmentSearch
    enrollmentSearch: EnrollmentSearch[] | null = []
    enrollmentIpadSearch: EnrollmentSearch[] = new Array<EnrollmentSearch>()
    enrollmentConsumerSearch: EnrollmentSearch[] = new Array<EnrollmentSearch>()
    electionPeriods: ValidatedRadioButtonModel[] = [] as ValidatedRadioButtonModel[]
    enrollmentElectionTypes: EnrollmentElectionType[] = [] as EnrollmentElectionType[]
    @ViewChild('gridReference', { static: false }) myGrid: jqxGridComponent
    @ViewChild('gridReference1', { static: false }) myGrid1: jqxGridComponent
    @ViewChild('gridReference2', { static: false }) myGrid2: jqxGridComponent
    enrollmentViewModel: EnrollmentViewModel = new EnrollmentViewModel()
    getEnrollmentRequest: GetEnrollmentRequest = {} as GetEnrollmentRequest
    planList: PlanList[] = [] as PlanList[]
    start: string
    end: string
    saveSuccess: string
    checkval: boolean
    memberService: IPadHistory
    memberServicePDF: IPadPDF
    IPadPDF: IPadPDF[]
    downloadError: string
    public loading: boolean = false
    public loadingPortal: boolean = false
    public loadingConsumer: boolean = false
    public loadingIpad: boolean = false
    public loadingPDF: boolean = false
    ErrorMessages: any[]
    validForm: boolean = true
    public recordsNotFound: boolean = false
    totalCountPortal: number | undefined = undefined
    totalCountConsumer: number | undefined = undefined
    totalCountIPad: number | undefined = undefined
    chunkSize: number = 10000
    jqxgridvirtualpaging: JqxGridVirtualPaging
    jqxgridConsumervirtualpaging: JqxGridVirtualPaging
    listretriveModel: EnrollmentSearch[]
    showPortalEnrollment: boolean = false
    showConsumerEnrollment: boolean = false
    showIPADEnrollment: boolean = false
    @ViewChild('focusableEleTop', { static: true }) focusableEleTop: ElementRef
    skipCallPortal: boolean
    skipCallConsumer: boolean
    skipCallIPad: boolean
    iPadRecordsNotFound: boolean = false
    consumerRecordsNotFound: boolean = false
    eventObj: any
    gridObj: jqxGridComponent
    icName: string
    hideIpad: boolean
    hideAppRecAndSave: boolean = false
    public currentUser: CurrentUser = {} as CurrentUser
    selectedPlanYear: number

    source: any = {
        dataFields: [
            { name: 'totalCount', type: 'number' },
            { name: 'FirstName', type: 'string' },
            { name: 'EnrollmentId', type: 'string' },
            { name: 'LastName', type: 'string' },
            { name: 'AgentID', type: 'string' },
            { name: 'DOB', type: 'date' },
            { name: 'HICN', type: 'string' },
            { name: 'confirmationNumber', type: 'string' },
            { name: 'CUID', type: 'string' },
            { name: 'ApplicationDate', type: 'date' },
            { name: 'EffectiveDate', type: 'date' },
            { name: 'PlanType', type: 'string' },
            { name: 'PlanYear', type: 'string' },
            { name: 'Status', type: 'string' },
            { name: 'AppRcvd', type: 'number', editrules: { edithidden: false } },
            { name: 'SaveRcvd', type: 'number' },
            { name: 'EnrollmentKey', type: 'string' }
        ],
        dataType: 'json',
        localData: this.enrollmentSearch,
        totalrecords: this.totalCountPortal,
        pagenum: 0,
        pagesize: 50
    }

    ready = (): void => {
        if (this.myGrid !== undefined) this.myGrid.localizestrings(this.jqxgridvirtualpaging.ready())
    }
    ready1 = (): void => {
        if (this.myGrid1 !== undefined) this.myGrid1.localizestrings(this.jqxgridvirtualpaging.ready())
    }
    ready2 = (): void => {
        if (this.myGrid2 !== undefined) this.myGrid2.localizestrings(this.jqxgridConsumervirtualpaging.ready())
    }

    updatefilterconditions = (type: string, defaultconditions: any): string[] | undefined => {
        return this.jqxgridvirtualpaging.updatefilterconditions(type)
    }

    updateConsumerfilterconditions = (type: string, defaultconditions: any): string[] | undefined => {
        return this.jqxgridConsumervirtualpaging.updatefilterconditions(type)
    }

    onFilter(event: any): void {
        console.log('In Filter Erollment Serach')
        if (this.skipCallPortal !== undefined) {
            if (!this.skipCallPortal) {
                this.loadingPortal = true
                this.skipCallPortal = true
                let filterinfo = this.myGrid.getfilterinformation()
                this.fmoModelPortal.FilterCriteria = this.jqxgridvirtualpaging.onFilter(event, filterinfo)

                this.getCustomSearchList(this.fmoModelPortal)
            }
        }
    }
    onIPADFilter(event: any): void {
        if (!this.skipCallIPad) {
            this.skipCallIPad = true
            this.loadingIpad = true
            let filterinfo = this.myGrid1.getfilterinformation()
            this.fmoModelPortal.FilterCriteria = this.jqxgridvirtualpaging.onFilter(event, filterinfo)

            this.getIpadSearchList(this.fmoModelPortal)
            //let EnrollmentIPADSearchListDataData: EnrollmentSearch[] = this._reportsGateway.getIpadSearchListSync(this.fmoModelPortal)
            //if ((EnrollmentIPADSearchListDataData !== null || EnrollmentIPADSearchListDataData !== undefined) && EnrollmentIPADSearchListDataData.length > 0) {
            //    this.showIPADEnrollment = true
            //    this.listretriveModel = EnrollmentIPADSearchListDataData
            //    this.source1.localData = EnrollmentIPADSearchListDataData
            //    this.source1.totalrecords = EnrollmentIPADSearchListDataData.length
            //    this.dataAdapter1.dataBind()
            //    this.myGrid1.updatebounddata()
            //    this.loadingIpad = false
            //} else {
            //    this.showIPADEnrollment = false
            //    this.source1.localData = null
            //    this.source1.totalrecords = 0
            //    this.loading = false
            //    this.dataAdapter1.dataBind()
            //    this.myGrid1.updatebounddata()
            //    this.loadingIpad = false
            //}
            //this.skipCallIPad = false
        }
    }

    onConsumerFilter(event: any): void {
        console.log('In Filter Erollment Serach')
        if (!this.skipCallConsumer) {
            this.loadingConsumer = true
            this.skipCallConsumer = true
            let filterinfo = this.myGrid2.getfilterinformation()
            this.fmoModelConsumer.FilterCriteria = this.jqxgridConsumervirtualpaging.onFilter(event, filterinfo)

            this.getConsumerSearchList(this.fmoModelConsumer, '')
            //    let EnrollmentConsumerSearchListDataData: EnrollmentSearch[] = this._reportsGateway.getConsumerSearchListSync(this.fmoModelPortal)
            //    if ((EnrollmentConsumerSearchListDataData !== null || EnrollmentConsumerSearchListDataData !== undefined) && EnrollmentConsumerSearchListDataData.length > 0) {
            //        this.showConsumerEnrollment = true
            //        this.listretriveModel = EnrollmentConsumerSearchListDataData
            //        this.source2.localData = EnrollmentConsumerSearchListDataData
            //        this.source2.totalrecords = EnrollmentConsumerSearchListDataData.length
            //        this.dataAdapter2.dataBind()
            //        this.myGrid2.updatebounddata()
            //        this.loadingConsumer = false
            //    } else {
            //        this.showConsumerEnrollment = false
            //        this.source2.localData = null
            //        this.source2.totalrecords = 0
            //        this.loading = false
            //        this.dataAdapter2.dataBind()
            //        this.myGrid2.updatebounddata()
            //        this.loadingConsumer = false
            //    }
            //    this.skipCallConsumer = false
        }
    }

    //cellsRenderer: function (row, columnfield, value, id, rowData) {
    cellbeginedit = (row: number, datafield: string, columntype: any, value: any, id: number, rowData: any): void | boolean => {
        var data = this.myGrid.getrowdata(row)
        if (data.CUID === '9110' || data.SaveRcvd === 2) {
            return false
        }
    }
    cellIPADBeginEdit = (row: number, datafield: string, columntype: any, value: any, id: number, rowData: any): void | boolean => {
        var data = this.myGrid1.getrowdata(row)
        if (data.SaveRcvd === 2) {
            return false
        }
    }

    source1: any = {
        dataFields: [
            { name: 'totalCount', type: 'number' },
            { name: 'FirstName', type: 'string' },
            { name: 'PreEnrollmentID', type: 'string' },
            { name: 'LastName', type: 'string' },
            { name: 'AgentID', type: 'string' },
            { name: 'DOB', type: 'date' },
            { name: 'HICN', type: 'string' },
            { name: 'confirmationNumber', type: 'string' },
            { name: 'CUID', type: 'string' },
            { name: 'ApplicationDate', type: 'date' },
            { name: 'EffectiveDate', type: 'date' },
            { name: 'PlanType', type: 'string' },
            { name: 'PlanYear', type: 'string' },
            { name: 'Status', type: 'string' },
            { name: 'EnrollmentKey', type: 'string' },
            { name: 'PreEnrollmentID', type: 'number' },
            { name: 'AppRcvd', type: 'number' },
            { name: 'SaveRcvd', type: 'number' }
        ],
        dataType: 'json',
        localData: this.enrollmentIpadSearch,
        totalrecords: this.totalCountIPad,
        pagenum: 0,
        pagesize: 50
    }
    source2: any = {
        dataFields: [
            { name: 'totalCount', type: 'number' },
            { name: 'FirstName', type: 'string' },
            { name: 'LastName', type: 'string' },
            { name: 'AgentID', type: 'string' },
            { name: 'DOB', type: 'date' },
            { name: 'HICN', type: 'string' },
            { name: 'confirmationNumber', type: 'string' },
            { name: 'CUID', type: 'string' },
            { name: 'ApplicationDate', type: 'date' },
            { name: 'EffectiveDate', type: 'date' },
            { name: 'PlanType', type: 'string' },
            { name: 'PlanYear', type: 'string' },
            { name: 'Status', type: 'string' },
            { name: 'EnrollmentKey', type: 'string' },
            { name: 'PreEnrollmentID', type: 'number' }
        ],
        dataType: 'json',
        localData: this.enrollmentConsumerSearch,
        totalrecords: this.totalCountConsumer,
        pagenum: 0,
        pagesize: 50
    }
    dataAdapter: any = new jqx.dataAdapter(this.source)
    //AppRcvd - 0 -- unchecked, 1 - checked , 2 -- disabled.
    //SaveRcvd - 0 -- red, 1 - green , 2 -- disabled.
    columns: any[] = [
        { text: 'First Name', dataField: 'FirstName', width: '7%' },
        { text: 'EnrollmentId', dataField: 'EnrollmentId', width: '7%', hidden: true },
        { text: 'Last Name', dataField: 'LastName', width: '7%' },
        { text: 'Agent ID', dataField: 'AgentID', width: '7%' },
        { text: 'Date of Birth', dataField: 'DOB', width: '6%', cellsformat: 'd' },
        { text: 'Medicare Number', dataField: 'HICN', width: '9%' },
        { text: 'Confirmation Number', dataField: 'confirmationNumber', width: '11%' },
        { text: 'CUID', dataField: 'CUID', width: '5%' },
        { text: 'Application Date', dataField: 'ApplicationDate', width: '10%', cellsformat: 'd' },
        { text: 'Effective Date', dataField: 'EffectiveDate', width: '6%', cellsformat: 'd' },
        { text: 'Plan Type', dataField: 'PlanType', width: '8%' },
        { text: 'Plan Year', dataField: 'PlanYear', width: '5%' },
        { text: 'Status', dataField: 'Status', width: '5%' },
        {
            text: 'Action',
            dataField: 'EnrollmentKey',
            editable: false,
            width: '5%',
            filterable: false,
            sortable: false,
            cellsRenderer: function (row, columnfield, value) {
                return ' <div class="jqx-grid-cell-left-align" style="margin-top:5px;"><a> PDF </a></div>'
            }
        },
        {
            text: 'App Rec',
            dataField: 'AppRcvd',
            columntype: 'checkbox',
            width: '5%',
            filterable: false,
            sortable: false,
            cellbeginedit: this.cellbeginedit,
            hidden: this.currentUser.isEViewer
        },

        {
            text: 'Save',
            dataField: 'SaveRcvd',
            editable: false,
            width: '5%',
            filterable: false,
            sortable: false,
            hidden: this.currentUser.isEViewer || this.currentUser.isAuditor,
            cellsRenderer: function (row, columnfield, value) {
                //Red
                if (value === 0) {
                    return '<a><img alt="save icon" style="width:16px; margin:7px;" src="data:image/svg+xml;charset=utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTQ0OC42LDM1MS44Yy0xOC40LDAtMzMuNCwxNS0zMy40LDMzLjR2NTIuMUg5Ni44di01Mi4xYzAtMTguNC0xNS0zMy40LTMzLjQtMzMuNFMzMCwzNjYuNywzMCwzODUuMnY4NS41CgkJYzAsMTguNCwxNSwzMy40LDMzLjQsMzMuNGgzODUuMmMxOC40LDAsMzMuNC0xNSwzMy40LTMzLjR2LTg1LjVDNDgyLDM2Ni43LDQ2Ny4xLDM1MS44LDQ0OC42LDM1MS44eiIvPgoJPHBhdGggZD0iTTI0NS45LDM4Ny4zYzUuNiw1LjYsMTQuNiw1LjYsMjAuMiwwbDExNy0xMTdjMy40LTMuNCw0LjQtOC41LDIuNi0xM2MtMS44LTQuNC02LjItNy40LTExLTcuNGgtNTVWMzQKCQljMC0xNC40LTExLjctMjYuMS0yNi4xLTI2LjFoLTc1LjNjLTE0LjQsMC0yNi4xLDExLjctMjYuMSwyNi4xdjIxNS45aC01NWMtNC44LDAtOS4yLDIuOS0xMSw3LjRjLTEuOCw0LjUtMC44LDkuNiwyLjYsMTMKCQlMMjQ1LjksMzg3LjN6Ii8+CjwvZz4KPC9zdmc+Cg==" /></a>'
                }
                //Green
                else if (value === 1) {
                    return '<a><img alt="save icon" style="width:16px; margin:7px;" src="data:image/svg+xml;charset=utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6I0E3Q0UzOTt9Cjwvc3R5bGU+CjxnPgoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTQ0OC42LDM1MS44Yy0xOC40LDAtMzMuNCwxNS0zMy40LDMzLjR2NTIuMUg5Ni44di01Mi4xYzAtMTguNC0xNS0zMy40LTMzLjQtMzMuNFMzMCwzNjYuNywzMCwzODUuMnY4NS41CgkJYzAsMTguNCwxNSwzMy40LDMzLjQsMzMuNGgzODUuMmMxOC40LDAsMzMuNC0xNSwzMy40LTMzLjR2LTg1LjVDNDgyLDM2Ni43LDQ2Ny4xLDM1MS44LDQ0OC42LDM1MS44eiIvPgoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTI0NS45LDM4Ny4zYzUuNiw1LjYsMTQuNiw1LjYsMjAuMiwwbDExNy0xMTdjMy40LTMuNCw0LjQtOC41LDIuNi0xM2MtMS44LTQuNC02LjItNy40LTExLTcuNGgtNTVWMzQKCQljMC0xNC40LTExLjctMjYuMS0yNi4xLTI2LjFoLTc1LjNjLTE0LjQsMC0yNi4xLDExLjctMjYuMSwyNi4xdjIxNS45aC01NWMtNC44LDAtOS4yLDIuOS0xMSw3LjRjLTEuOCw0LjUtMC44LDkuNiwyLjYsMTMKCQlMMjQ1LjksMzg3LjN6Ii8+CjwvZz4KPC9zdmc+Cg==" /></a>'
                }
                //Disabled
                else {
                    return '<a><img alt="save icon" style="width:16px; margin:7px;" src="data:image/svg+xml;charset=utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6I0QxQ0NDQzt9Cjwvc3R5bGU+CjxnPgoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTQ0OC42LDM1MS44Yy0xOC40LDAtMzMuNCwxNS0zMy40LDMzLjR2NTIuMUg5Ni44di01Mi4xYzAtMTguNC0xNS0zMy40LTMzLjQtMzMuNFMzMCwzNjYuNywzMCwzODUuMnY4NS41CgkJYzAsMTguNCwxNSwzMy40LDMzLjQsMzMuNGgzODUuMmMxOC40LDAsMzMuNC0xNSwzMy40LTMzLjR2LTg1LjVDNDgyLDM2Ni43LDQ2Ny4xLDM1MS44LDQ0OC42LDM1MS44eiIvPgoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTI0NS45LDM4Ny4zYzUuNiw1LjYsMTQuNiw1LjYsMjAuMiwwbDExNy0xMTdjMy40LTMuNCw0LjQtOC41LDIuNi0xM2MtMS44LTQuNC02LjItNy40LTExLTcuNGgtNTVWMzQKCQljMC0xNC40LTExLjctMjYuMS0yNi4xLTI2LjFoLTc1LjNjLTE0LjQsMC0yNi4xLDExLjctMjYuMSwyNi4xdjIxNS45aC01NWMtNC44LDAtOS4yLDIuOS0xMSw3LjRjLTEuOCw0LjUtMC44LDkuNiwyLjYsMTMKCQlMMjQ1LjksMzg3LjN6Ii8+CjwvZz4KPC9zdmc+Cg==" /></a>'
                }
            }
        }
    ]

    dataAdapter1: any = new jqx.dataAdapter(this.source1)
    columns1: any[] = [
        { text: 'First Name', dataField: 'FirstName', width: 95 },
        { name: 'PreEnrollmentID', type: 'string', width: 95, hidden: true },
        { text: 'Last Name', dataField: 'LastName', width: 95 },
        { text: 'Agent ID', dataField: 'AgentID', width: 95 },
        { text: 'Date of Birth', dataField: 'DOB', width: 80, cellsformat: 'd' },
        { text: 'Medicare Number', dataField: 'HICN', width: 110 },
        { text: 'Confirmation Number', dataField: 'confirmationNumber', width: 140 },
        { text: 'CUID', dataField: 'CUID', width: 55 },
        { text: 'Application Date', dataField: 'ApplicationDate', width: 100, cellsformat: 'd' },
        { text: 'Effective Date', dataField: 'EffectiveDate', width: 79, cellsformat: 'd' },
        { text: 'Plan Type', dataField: 'PlanType', width: 88 },
        { text: 'Plan Year', dataField: 'PlanYear', width: 54 },
        { text: 'Status', dataField: 'Status', width: 70 },
        {
            text: 'Action',
            dataField: 'PreEnrollmentID',
            editable: false,
            width: 63,
            filterable: false,
            sortable: false,
            cellsRenderer: function (row, columnfield, value) {
                return ' <div class="jqx-grid-cell-left-align" style="margin-top:5px;"><a> PDF </a></div>'
            }
        },
        {
            text: 'App Rec',
            datafield: 'AppRcvd',
            columntype: 'checkbox',
            width: 50,
            filterable: false,
            sortable: false,
            cellbeginedit: this.cellIPADBeginEdit,
            hidden: this.currentUser.isEViewer
        },
        {
            text: 'Save',
            dataField: 'SaveRcvd',
            editable: false,
            width: 53,
            filterable: false,
            sortable: false,
            hidden: this.currentUser.isEViewer || this.currentUser.isAuditor,
            cellsRenderer: function (row, columnfield, value) {
                //Red
                if (value === 0) {
                    return '<a><img alt="save icon" style="width:16px; margin:7px;" src="data:image/svg+xml;charset=utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTQ0OC42LDM1MS44Yy0xOC40LDAtMzMuNCwxNS0zMy40LDMzLjR2NTIuMUg5Ni44di01Mi4xYzAtMTguNC0xNS0zMy40LTMzLjQtMzMuNFMzMCwzNjYuNywzMCwzODUuMnY4NS41CgkJYzAsMTguNCwxNSwzMy40LDMzLjQsMzMuNGgzODUuMmMxOC40LDAsMzMuNC0xNSwzMy40LTMzLjR2LTg1LjVDNDgyLDM2Ni43LDQ2Ny4xLDM1MS44LDQ0OC42LDM1MS44eiIvPgoJPHBhdGggZD0iTTI0NS45LDM4Ny4zYzUuNiw1LjYsMTQuNiw1LjYsMjAuMiwwbDExNy0xMTdjMy40LTMuNCw0LjQtOC41LDIuNi0xM2MtMS44LTQuNC02LjItNy40LTExLTcuNGgtNTVWMzQKCQljMC0xNC40LTExLjctMjYuMS0yNi4xLTI2LjFoLTc1LjNjLTE0LjQsMC0yNi4xLDExLjctMjYuMSwyNi4xdjIxNS45aC01NWMtNC44LDAtOS4yLDIuOS0xMSw3LjRjLTEuOCw0LjUtMC44LDkuNiwyLjYsMTMKCQlMMjQ1LjksMzg3LjN6Ii8+CjwvZz4KPC9zdmc+Cg==" /></a>'
                }
                //Green
                else if (value === 1) {
                    return '<a><img alt="save icon" style="width:16px; margin:7px;" src="data:image/svg+xml;charset=utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6I0E3Q0UzOTt9Cjwvc3R5bGU+CjxnPgoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTQ0OC42LDM1MS44Yy0xOC40LDAtMzMuNCwxNS0zMy40LDMzLjR2NTIuMUg5Ni44di01Mi4xYzAtMTguNC0xNS0zMy40LTMzLjQtMzMuNFMzMCwzNjYuNywzMCwzODUuMnY4NS41CgkJYzAsMTguNCwxNSwzMy40LDMzLjQsMzMuNGgzODUuMmMxOC40LDAsMzMuNC0xNSwzMy40LTMzLjR2LTg1LjVDNDgyLDM2Ni43LDQ2Ny4xLDM1MS44LDQ0OC42LDM1MS44eiIvPgoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTI0NS45LDM4Ny4zYzUuNiw1LjYsMTQuNiw1LjYsMjAuMiwwbDExNy0xMTdjMy40LTMuNCw0LjQtOC41LDIuNi0xM2MtMS44LTQuNC02LjItNy40LTExLTcuNGgtNTVWMzQKCQljMC0xNC40LTExLjctMjYuMS0yNi4xLTI2LjFoLTc1LjNjLTE0LjQsMC0yNi4xLDExLjctMjYuMSwyNi4xdjIxNS45aC01NWMtNC44LDAtOS4yLDIuOS0xMSw3LjRjLTEuOCw0LjUtMC44LDkuNiwyLjYsMTMKCQlMMjQ1LjksMzg3LjN6Ii8+CjwvZz4KPC9zdmc+Cg==" /></a>'
                }
                //Disabled
                else {
                    return '<a><img alt="save icon" style="width:16px; margin:7px;" src="data:image/svg+xml;charset=utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6I0QxQ0NDQzt9Cjwvc3R5bGU+CjxnPgoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTQ0OC42LDM1MS44Yy0xOC40LDAtMzMuNCwxNS0zMy40LDMzLjR2NTIuMUg5Ni44di01Mi4xYzAtMTguNC0xNS0zMy40LTMzLjQtMzMuNFMzMCwzNjYuNywzMCwzODUuMnY4NS41CgkJYzAsMTguNCwxNSwzMy40LDMzLjQsMzMuNGgzODUuMmMxOC40LDAsMzMuNC0xNSwzMy40LTMzLjR2LTg1LjVDNDgyLDM2Ni43LDQ2Ny4xLDM1MS44LDQ0OC42LDM1MS44eiIvPgoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTI0NS45LDM4Ny4zYzUuNiw1LjYsMTQuNiw1LjYsMjAuMiwwbDExNy0xMTdjMy40LTMuNCw0LjQtOC41LDIuNi0xM2MtMS44LTQuNC02LjItNy40LTExLTcuNGgtNTVWMzQKCQljMC0xNC40LTExLjctMjYuMS0yNi4xLTI2LjFoLTc1LjNjLTE0LjQsMC0yNi4xLDExLjctMjYuMSwyNi4xdjIxNS45aC01NWMtNC44LDAtOS4yLDIuOS0xMSw3LjRjLTEuOCw0LjUtMC44LDkuNiwyLjYsMTMKCQlMMjQ1LjksMzg3LjN6Ii8+CjwvZz4KPC9zdmc+Cg==" /></a>'
                }
            }
        }
    ]

    dataAdapter2: any = new jqx.dataAdapter(this.source2)
    columns2: any[] = [
        { text: 'First Name', dataField: 'FirstName', width: 120 },
        { text: 'Last Name', dataField: 'LastName', width: 120 },
        { text: 'Agent ID', dataField: 'AgentID', width: 110 },
        { text: 'Date of Birth', dataField: 'DOB', width: 85, cellsformat: 'd' },
        { text: 'Medicare Number', dataField: 'HICN', width: 120 },
        { text: 'Confirmation Number', dataField: 'confirmationNumber', width: 150 },
        { text: 'CUID', dataField: 'CUID', width: 60 },
        { text: 'Application Date', dataField: 'ApplicationDate', width: 100, cellsformat: 'd' },
        { text: 'Effective Date', dataField: 'EffectiveDate', width: 82, cellsformat: 'd' },
        { text: 'Plan Type', dataField: 'PlanType', width: 88 },
        { text: 'Plan Year', dataField: 'PlanYear', width: 55 },
        { text: 'Status', dataField: 'Status', width: 70 },
        {
            text: 'Action',
            dataField: 'PreEnrollmentID',
            editable: false,
            width: 67,
            filterable: false,
            sortable: false,
            cellsRenderer: function (row, columnfield, value) {
                return '<div class="jqx-grid-cell-left-align" style="margin-top:5px;"><a> PDF </a></div>'
            }
        }
    ]

    constructor(
        private _reportsGateway: ReportsGateway,
        public _global: PortalGlobals,
        private _enrollementGateway: EnrollmentGateway,
        private _userGateway: UserGateway,
        private _networkUserAccessGateway: UserAccessGateway,
        private _excelService: ExcelService
    ) {
        ;(this.memberService = {} as IPadHistory), (this.memberServicePDF = {} as IPadPDF)
        this.jqxgridvirtualpaging = new JqxGridVirtualPaging()
        this.jqxgridConsumervirtualpaging = new JqxGridVirtualPaging()
        this.hideIpad = true

        this.ngOnInit()
    }

    ngOnInit(): void {
        this.loadingPortal = true
        var User = localStorage.getItem('UserSessionContext')
        this.currentUser = JSON.parse(User!)
        if (this.currentUser !== null && this.currentUser !== undefined && this.currentUser.insuranceCompanyName !== undefined) {
            this.icName = this.currentUser.insuranceCompanyName
            if (this.icName === this._global.insuranceCompanyNameNEJE) {
                this.hideIpad = false
                this.hideAppRecAndSave = true
            } else {
                this.hideIpad = true
            }
        } else {
            this._networkUserAccessGateway.getCurrentUser().subscribe((currentUserModel: CurrentUser) => {
                this.currentUser = currentUserModel
                this.icName = this.currentUser.insuranceCompanyName
                if (this.icName === this._global.insuranceCompanyNameNEJE) {
                    this.hideIpad = false
                } else {
                    this.hideIpad = true
                }
            })
        }

        this.getLeadTypes()
        this.getStatusList()
        this.getSearchFilterList()
        this.fmoModelPortal = this.fmoModelConsumer = this.fmoModelIPad = {} as SearchModel

        this.enrollmentSearchModel = {} as EnrollmentSearch
        let today = new Date()
        var year = this._global.selectedPlanYear

        if (year === 0) {
            year = parseInt(moment().format('YYYY'))
        }

        var month = 9
        var day = 1
        this.fmoModelPortal.StartDate =
            this.fmoModelConsumer.StartDate =
            this.fmoModelIPad.StartDate =
            moment().date(day).month(month).year(year).subtract(1, 'years').format('M/D/YYYY')

        // this.FmoModel.StartDate = moment('10 / 1 / 2018').subtract('years',1).toDate();
        this.fmoModelPortal.EndDate = this.fmoModelConsumer.EndDate = this.fmoModelIPad.EndDate = moment(today).format('M/D/YYYY')
        this.saveSuccess = ''
        this.fmoModelPortal.PageNumber = this.fmoModelConsumer.PageNumber = this.fmoModelIPad.PageNumber = 1
        this.fmoModelPortal.PageSize = this.fmoModelConsumer.PageSize = this.fmoModelIPad.PageSize = 50
        this.loadingPortal = false
    }

    CellclickOnEdit(event: any): void {
        if (
            event.args.datafield === 'SaveRcvd' ||
            event.args.datafield === 'PreEnrollmentID' ||
            event.args.datafield === 'AppRcvd' ||
            event.args.datafield === 'EnrollmentKey'
        ) {
            let enrollmentId = event.args.row.bounddata.EnrollmentId
            let appRcvd = event.args.row.bounddata.AppRcvd
            if (enrollmentId !== undefined && enrollmentId !== 0) {
                if (this.enrollmentSearch != null && this.enrollmentSearch !== undefined && this.enrollmentSearch.length > 0) {
                    for (let i = 0; i < this.enrollmentSearch.length; i++) {
                        if (this.enrollmentSearch[i].SaveRcvd !== 2) {
                            if (enrollmentId === this.enrollmentSearch[i].EnrollmentId) {
                                this.enrollmentSearch[i].SaveRcvd = appRcvd
                                this.enrollmentSearch[i].AppRcvd = appRcvd
                                this.source.localdata = this.enrollmentSearch
                                this.skipCallPortal = true
                                this.dataAdapter.dataBind()
                                this.myGrid.updatebounddata()
                                this.myGrid.autoshowfiltericon(true)
                                this.skipCallPortal = false
                            }
                        }
                    }
                }
            }

            let preenrollmentId = event.args.row.bounddata.PreEnrollmentID
            if (preenrollmentId !== undefined && preenrollmentId !== 0) {
                if (this.enrollmentIpadSearch !== undefined && this.enrollmentIpadSearch.length > 0) {
                    for (let i = 0; i < this.enrollmentIpadSearch.length; i++) {
                        if (this.enrollmentIpadSearch[i].SaveRcvd !== 2) {
                            if (preenrollmentId === this.enrollmentIpadSearch[i].PreEnrollmentID) {
                                this.enrollmentIpadSearch[i].SaveRcvd = appRcvd
                                this.enrollmentIpadSearch[i].AppRcvd = appRcvd
                                this.source1.localdata = this.enrollmentIpadSearch
                                this.skipCallIPad = true
                                this.dataAdapter1.dataBind()
                                this.myGrid1.updatebounddata()
                                this.myGrid1.autoshowfiltericon(true)
                                this.skipCallIPad = false
                            }
                        }
                    }
                }
            }

            //if (event.args.datafield === 'EnrollmentKey') {
            //    let enrollKey = event.args.row.bounddata.EnrollmentKey
            //    this.DownloadPDF(enrollKey)
            //}

            console.log('EnrollmentId: ' + enrollmentId)

            if (enrollmentId !== undefined && enrollmentId !== 0 && event.args.datafield !== 'SaveRcvd') {
                // console.log("EnrollmentId: " + enrollmentId)
                this.DownloadEnrollmentPDF(enrollmentId)
            }

            if (event.args.datafield === 'PreEnrollmentID') {
                this.downloadPDFIPad(event.args.row.bounddata.confirmationNumber, event.args.row.bounddata.PreEnrollmentID)
            }
            if (event.args.datafield === 'SaveRcvd') {
                let confirmationNumber = event.args.row.bounddata.confirmationNumber
                let cuid = event.args.row.bounddata.CUID
                if (event.args.row.bounddata.SaveRcvd !== 2) {
                    let apprcvd = false
                    if (event.args.row.bounddata.AppRcvd !== undefined && event.args.row.bounddata.AppRcvd === 1) {
                        apprcvd = event.args.row.bounddata.AppRcvd
                    }
                    this.SaveEnrollment(confirmationNumber, apprcvd)
                }
            }
            this.source.localdata = this.enrollmentSearch
            this.skipCallPortal = true
            this.dataAdapter.dataBind()
            this.myGrid.updatebounddata()
            this.skipCallPortal = false
        }
    }

    getLeadTypes() {
        this._reportsGateway.getLeadTypes().subscribe((data) => {
            this.LeadTypes = data
        })
    }
    getStatusList() {
        this._reportsGateway.getStatusList().subscribe((data) => {
            this.statusList = data
        })
    }

    getSearchFilterList() {
        this._reportsGateway.getSearchFilterList().subscribe((data) => {
            this.searchList = data
        })
    }

    Cellclick(event: any): void {
        if (event.args.datafield === 'Save') {
            // SaveEnrollment()
        }
        /* if (event.args.datafield === 'checked') {
            this.getCheckedPlans(event)
        } */
    }

    SearchEnrollment(ListValueId: string, Status: string, LeadTypeValue: string): void {
        // alert(this.start);
        this.saveSuccess = ''
        this.ErrorMessages = []
        this.validForm = true
        if (
            ListValueId !== 'All' &&
            (this.fmoModelPortal.searchText === undefined || this.fmoModelPortal.searchText === null || this.fmoModelPortal.searchText === '')
        ) {
            this.validForm = false
            this.ErrorMessages.push('Please enter Search Criteria')
        } else {
            this.validForm = true
            if (ListValueId != null && ListValueId != undefined) {
                if (ListValueId == 'Confirmation Number') {
                    if (this.icName === this._global.insuranceCompanyNameNEJE) {
                        this.fmoModelPortal.listName = this.fmoModelConsumer.listName = 'ConfirmationNumber'
                    } else {
                        this.fmoModelPortal.listName = this.fmoModelConsumer.listName = this.fmoModelIPad.listName = 'ConfirmationNumber'
                    }
                } else {
                    if (this.icName === this._global.insuranceCompanyNameNEJE) {
                        this.fmoModelPortal.listName = this.fmoModelConsumer.listName = ListValueId
                    } else {
                        this.fmoModelPortal.listName = this.fmoModelConsumer.listName = this.fmoModelIPad.listName = ListValueId
                    }
                }
            }
            if (Status != null && Status != undefined) {
                this.fmoModelPortal.statusValue = this.fmoModelConsumer.statusValue = this.fmoModelIPad.statusValue = Status
            }
            if (LeadTypeValue != null && LeadTypeValue != undefined) {
                // LeadTypeID = 'S5601'
                if (this.icName === this._global.insuranceCompanyNameNEJE) {
                    this.fmoModelPortal.leadTypeValue = this.fmoModelConsumer.leadTypeValue = LeadTypeValue
                    this.fmoModelPortal.leadTypeID = this.fmoModelConsumer.leadTypeID = LeadTypeValue
                } else {
                    this.fmoModelPortal.leadTypeValue = this.fmoModelConsumer.leadTypeValue = this.fmoModelIPad.leadTypeValue = LeadTypeValue
                }
            }
            if (this.icName === this._global.insuranceCompanyNameNEJE) {
                this.fmoModelConsumer.StartDate = this.fmoModelPortal.StartDate = moment(this.fmoModelConsumer.StartDate).format('M/D/YYYY')
                this.fmoModelConsumer.EndDate = this.fmoModelPortal.EndDate = moment(this.fmoModelConsumer.EndDate).format('M/D/YYYY')
            } else {
                this.fmoModelConsumer.StartDate =
                    this.fmoModelIPad.StartDate =
                    this.fmoModelPortal.StartDate =
                    moment(this.fmoModelConsumer.StartDate).format('M/D/YYYY')
                this.fmoModelConsumer.EndDate =
                    this.fmoModelIPad.EndDate =
                    this.fmoModelPortal.EndDate =
                    moment(this.fmoModelConsumer.EndDate).format('M/D/YYYY')
            }

            // On every search button click removing the filter criteria.
            this.fmoModelConsumer.FilterCriteria = ''
            // this.fmoModelIPad.FilterCriteria = '';
            this.fmoModelPortal.FilterCriteria = ''
            this.skipCallPortal = true
            this.myGrid.clearfilters()
            // this.myGrid1.clearfilters()
            this.skipCallConsumer = true
            this.myGrid2.clearfilters()
            this.myGrid.removesort()
            //  this.myGrid1.removesort()
            this.myGrid2.removesort()
            if (this.icName !== this._global.insuranceCompanyNameNEJE) {
                this.fmoModelIPad.FilterCriteria = ''
                this.myGrid1.clearfilters()
                this.myGrid1.removesort()
            }
            if (this.icName === this._global.insuranceCompanyNameNEJE) {
                this.myGrid.setcolumnproperty('FirstName', 'width', '10%')
                this.myGrid.setcolumnproperty('LastName', 'width', '10%')
                this.myGrid.setcolumnproperty('AgentID', 'width', '10%')
                this.myGrid.hidecolumn('AppRcvd')
                this.myGrid.hidecolumn('SaveRcvd')
                this.myGrid2.hidecolumn('AppRcvd')
                this.myGrid2.hidecolumn('SaveRcvd')
            }
            //this.start = "03/01/2018"
            //this.end = "04/01/2018"
            //this.getCustomSearchList(ListValueId, Status, LeadTypeID, this.start, this.end)

            //if (LeadTypeValue === 'EMAIL' || LeadTypeValue === 'CONSUMER') {
            //    this.getConsumerSearchList(this.fmoModelConsumer)
            //}
            //else if (LeadTypeValue === 'IPAD' && this.icName !== this._global.insuranceCompanyNameNEJE) {
            //    this.getIpadSearchList(this.fmoModelIPad)
            //}
            //else if (LeadTypeValue === 'AP') {
            //    this.getCustomSearchList(this.fmoModelPortal)
            //}
            //else {
            //    this.getCustomSearchList(this.fmoModelPortal)
            //    if (this.icName !== this._global.insuranceCompanyNameNEJE) {

            //        this.getIpadSearchList(this.fmoModelIPad)
            //    }
            //    this.getConsumerSearchList(this.fmoModelConsumer)
            //}

            if (LeadTypeValue === 'AP') {
                this.getCustomSearchList(this.fmoModelPortal)
            } else if (LeadTypeValue === 'All') {
                this.getCustomSearchList(this.fmoModelPortal)
                if (this.icName !== this._global.insuranceCompanyNameNEJE) {
                    this.getIpadSearchList(this.fmoModelIPad)
                }
                //if (this.icName !== this._global.insuranceCompanyNameNEJE) {
                this.getConsumerSearchList(this.fmoModelConsumer, LeadTypeValue)
                //}
            } else if (LeadTypeValue === 'EMAIL' || LeadTypeValue === 'CONSUMER') {
                //if (this.icName === this._global.insuranceCompanyNameNEJE) {
                //    this.getCustomSearchList(this.fmoModelPortal)
                //}
                //else
                this.getConsumerSearchList(this.fmoModelConsumer, LeadTypeValue)
            } else if (LeadTypeValue === 'IPAD' && this.icName !== this._global.insuranceCompanyNameNEJE) {
                this.getIpadSearchList(this.fmoModelIPad)
            }
        }
    }

    cellEndEditEvent(event: any): void {
        let args = event.args
        this.checkval = !event.args.oldvalue
    }

    //getCustomSearchList(ListValueId: number, Status: number, LeadTypeID: string, start: string, end: string) {

    //    this._reportsGateway.getCustomSearchList(ListValueId, Status, LeadTypeID, start, end)
    //        .subscribe(data => {
    //            this.enrollmentSearch = data
    //        })
    //}
    getCustomSearchList(FmoModel: SearchModel) {
        this.loadingPortal = true
        this.recordsNotFound = false
        this.skipCallPortal = true
        this._reportsGateway.getCustomSearchList(FmoModel).subscribe({
            next: (data) => {
                if (data.length > 0) {

                    this.showPortalEnrollment = true
                    data.map((row) => {
                        row.ApplicationDate = row.ApplicationDate ? moment(row.ApplicationDate).format('M/D/YYYY') : row.ApplicationDate
                        row.EffectiveDate = row.EffectiveDate ? moment(row.EffectiveDate).format('M/D/YYYY') : row.EffectiveDate
                        row.DOB = row.DOB ? moment(row.DOB).format('M/D/YYYY') : row.DOB
                    })
                    this.enrollmentSearch = data
                    this.source.localdata = this.enrollmentSearch
                    this.totalCountPortal = this.source.totalrecords = data[0].TotalCount
                    this.source.pagenum = FmoModel.PageNumber
                    this.source.pagesize = FmoModel.PageSize
                    this.dataAdapter.dataBind()
                    // this.myGrid.updatebounddata()
                    this.myGrid.autoshowfiltericon(true)
                    this.loadingPortal = false

                    setTimeout(() => {
                        if (this.icName === this._global.insuranceCompanyNameNEJE) {
                            this.myGrid.setcolumnproperty('FirstName', 'width', '10%')
                            this.myGrid.setcolumnproperty('LastName', 'width', '10%')
                            this.myGrid.setcolumnproperty('AgentID', 'width', '10%')
                            this.myGrid.hidecolumn('AppRcvd')
                            this.myGrid.hidecolumn('SaveRcvd')
                            this.myGrid2.hidecolumn('AppRcvd')
                            this.myGrid2.hidecolumn('SaveRcvd')
                        }
                    }, 500);

                } else {
                    this.showPortalEnrollment = false
                    this.enrollmentSearch = null
                    this.recordsNotFound = true
                    if (this.icName === this._global.insuranceCompanyNameNEJE) {
                        this.iPadRecordsNotFound = true
                    }
                    this.loadingPortal = false
                }
                this.loadingPortal = false
                this.skipCallPortal = false
            },
            error: (err) => {
                this.loadingPortal = false
                this.recordsNotFound = true
            }
        })
    }

    getIpadSearchList(FmoModel: SearchModel) {
        this.loadingIpad = true
        this.skipCallIPad = true
        this.iPadRecordsNotFound = false
        this._reportsGateway.getIpadSearchList(FmoModel).subscribe(
            (data) => {
                if (data.length > 0) {
                    this.showIPADEnrollment = true
                    this.enrollmentIpadSearch = data
                    this.source1.localdata = this.enrollmentIpadSearch
                    this.totalCountIPad = this.source1.totalrecords = data[0].TotalCount
                    this.dataAdapter1.dataBind()
                    this.myGrid1.updatebounddata()
                    this.myGrid1.autoshowfiltericon(true)
                    this.loadingIpad = false
                } else {
                    this.showIPADEnrollment = false
                    this.totalCountIPad = this.source1.totalrecords = 0
                    this.myGrid1.updatebounddata()
                    this.myGrid1.autoshowfiltericon(true)
                    this.iPadRecordsNotFound = true
                    this.loadingIpad = false
                }
                this.skipCallIPad = false
            },
            (err) => {
                this.loadingIpad = false
            }
        )
    }

    getConsumerSearchList(FmoModel: SearchModel, LeadTypeValue: string) {
        this.loadingConsumer = true
        this.skipCallConsumer = true
        this.consumerRecordsNotFound = false
        //if (LeadTypeValue == 'CONSUMER') {
        //    this.recordsNotFound = false
        //}
        // if (this.icName !== this._global.insuranceCompanyNameNEJE) {

        this._reportsGateway.getConsumerSearchList(FmoModel).subscribe(
            (data) => {
                if (data.length > 0) {
                    this.showConsumerEnrollment = true
                    this.enrollmentConsumerSearch = data
                    this.source2.localdata = this.enrollmentConsumerSearch
                    this.totalCountConsumer = this.source2.totalrecords = data[0].TotalCount
                    this.dataAdapter2.dataBind()
                    this.myGrid2.updatebounddata()
                    //this.myGrid2.autoshowfiltericon(true)
                    this.loadingConsumer = false
                } else {
                    this.showConsumerEnrollment = false
                    this.totalCountConsumer = this.source2.totalrecords = 0
                    this.myGrid2.updatebounddata()
                    // this.myGrid2.autoshowfiltericon(true)
                    this.consumerRecordsNotFound = true
                    this.loadingConsumer = false
                }
                this.skipCallConsumer = false
            },
            (err) => {
                this.loadingConsumer = false
            }
        )
        //}
        //else {
        //    this.showConsumerEnrollment = false
        //    this.totalCountConsumer = this.source2.totalrecords = 0
        //    this.myGrid2.updatebounddata()
        //    this.myGrid2.autoshowfiltericon(true)
        //    this.consumerRecordsNotFound = true
        //    this.loadingConsumer = false

        //}
    }
    onStateChange(val: any) {}

    onSortConsumer(event: any): void {
        this.onSort(event, this.fmoModelConsumer)
        if (!this.skipCallConsumer) {
            this.getConsumerSearchList(this.fmoModelConsumer, '')
        }
    }

    onSortPortal(event: any): void {
        this.onSort(event, this.fmoModelPortal)
        if (!this.skipCallPortal) {
            this.getCustomSearchList(this.fmoModelPortal)
        }
    }

    onSortIPad(event: any): void {
        this.onSort(event, this.fmoModelIPad)
        if (!this.skipCallIPad) {
            this.getIpadSearchList(this.fmoModelIPad)
        }
    }

    onSort(event: any, fmoModel: SearchModel): void {
        let sortinformation = event.args.sortinformation
        let sortdirection = sortinformation.sortdirection.ascending ? 'ASC' : 'DESC'
        if (!sortinformation.sortdirection.ascending && !sortinformation.sortdirection.descending) {
            sortdirection = ''
        }
        if (sortdirection) {
            fmoModel.SortFields = `${sortinformation.sortcolumn} ${sortdirection}`
        } else {
            fmoModel.SortFields = ''
        }
    }

    onConsumerPageSizeChanged(event: any): void {
        let args = event.args
        this.source.pagesize = this.fmoModelConsumer.PageSize = args.pagesize
        if (!this.skipCallConsumer) {
            this.getConsumerSearchList(this.fmoModelConsumer, '')
        }
    }

    onPortalPageSizeChanged(event: any): void {
        let args = event.args
        this.source.pagesize = this.fmoModelPortal.PageSize = args.pagesize
        if (!this.skipCallPortal) {
            this.getCustomSearchList(this.fmoModelPortal)
        }
    }

    onIPadPageSizeChanged(event: any): void {
        let args = event.args
        this.source.pagesize = this.fmoModelIPad.PageSize = args.pagesize
        if (!this.skipCallIPad) {
            this.getIpadSearchList(this.fmoModelIPad)
        }
    }

    loadPlanList(AGENTORGID: number) {
        this._enrollementGateway.getPlanList(AGENTORGID, this._global.selectedPlanYear.toString()).subscribe((model: PlanList[]) => {
            if (model !== undefined) {
                let plans = model.filter((x) => x.PlanTypeShortName === this.enrollmentViewModel.PLANTYPE)
                if (plans !== undefined && plans.length > 0) {
                    this.enrollmentViewModel.PLANTYPENAME = plans[0].PlanTypeName
                } else {
                    this.enrollmentViewModel.PLANTYPENAME = this.enrollmentViewModel.PLANTYPE
                }

                this.SavePdf(this.enrollmentViewModel)
            }
        })
    }

    downloadPDFIPad(ConfirmationNumber, PreEnrollmentId) {
        console.log(ConfirmationNumber + ' ---this is ConfirmationNumber')
        console.log(PreEnrollmentId + ' ---this is  PreEnrollmentId')
        this.memberServicePDF.ConfirmationNumber = ConfirmationNumber
        this.memberServicePDF.PreEnrollmentId = PreEnrollmentId
        var fileName = ''
        this._enrollementGateway
            .getPDFFileName(this.memberServicePDF.ConfirmationNumber, this.memberServicePDF.PreEnrollmentId)
            .subscribe((model: IPadPDF[]) => {
                this.IPadPDF = model
                this._enrollementGateway.downloadPDFIPad(this.memberServicePDF).subscribe((model: any) => {
                    //base64 To ArrayBuffer
                    var binaryString = window.atob(model)
                    var binaryLen = binaryString.length
                    console.log('binaryLen' + binaryLen)
                    if (binaryLen == 3) {
                        console.log('File doesnt exist / some back ground  error')
                        this.downloadError = 'File Not Found'
                        return
                    }
                    this.downloadError = ''
                    var bytes = new Uint8Array(binaryLen)
                    for (var i = 0; i < binaryLen; i++) {
                        var ascii = binaryString.charCodeAt(i)
                        bytes[i] = ascii
                    }
                    fileName = this.IPadPDF[0].LastName + '-' + this.IPadPDF[0].FirstName + '.pdf'
                    // below code needed for ie browser
                    if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
                        ;(window.navigator as any).msSaveOrOpenBlob(new Blob([bytes], { type: 'application/pdf' }), fileName)
                    }
                    // for other browsers
                    var link = document.createElement('a')
                    link.href = URL.createObjectURL(new Blob([bytes]))
                    link.download = fileName
                    document.body.appendChild(link)
                    link.click()
                    // Revoking is tricky:
                    // https://code.google.com/p/chromium/issues/detail?id=375297#c7
                    window.setTimeout(function () {
                        URL.revokeObjectURL(link.href)
                        document.body.removeChild(link)
                    }, 100)
                })
            })
    }

    GetElectionCriteria() {
        //this.setData()

        let insuranceCoId = this.currentUser.insuranceCompanyId

        let _planYear = this.enrollmentViewModel.PLANYEAR
        if (_planYear === null || _planYear === undefined || _planYear === '') _planYear = this._global.selectedPlanYear.toString()

        this._enrollementGateway.getElectionDetails(this.enrollmentViewModel.CONF).subscribe(
            (model) => {
                this.enrollmentElectionTypes = model
                if (
                    this.enrollmentElectionTypes !== null &&
                    this.enrollmentElectionTypes !== undefined &&
                    this.enrollmentElectionTypes.length !== 0
                ) {
                    this.enrollmentViewModel.SEPREASONTEXT = this.enrollmentElectionTypes[0].LongDescription
                    this.enrollmentViewModel.SEPREASONCD = this.enrollmentElectionTypes[0].ElectionTypeReasonCode
                }
                this.GetAgentName(Number(this.enrollmentViewModel.AGENTID), this.enrollmentViewModel.ADMINID)
            },
            (err) => {
                this.loadingPDF = false
            }
        )
    }

    GetAgentName(agentId: number, adminId: number) {
        this._userGateway.retrieveUser(agentId).subscribe(
            (model) => {
                if (model.UserProfile.UserProfileName !== undefined) {
                    this.enrollmentViewModel.AGENTNAME = model.UserProfile.UserProfileName
                } else {
                    this.enrollmentViewModel.AGENTNAME = model.UserProfile.UserProfileName
                }
                //remove Agent name if userprofilename is SSIORGAGENT
                if (model.UserProfile.UserProfileName === 'SSIORGAGENT') {
                    this.enrollmentViewModel.AGENTNAME = ''
                }

                if (adminId === 0) {
                    this.enrollmentViewModel.USERNAME = ''
                    this.loadPlanList(model.UserProfile.OrgID)
                } else if (adminId === agentId) {
                    this.enrollmentViewModel.USERNAME = this.enrollmentViewModel.AGENTNAME
                    this.loadPlanList(model.UserProfile.OrgID)
                } else {
                    this._userGateway.retrieveUser(adminId).subscribe(
                        (model) => {
                            if (model.UserProfile.UserProfileName !== undefined) {
                                this.enrollmentViewModel.USERNAME = model.UserProfile.UserProfileName
                            } else {
                                this.enrollmentViewModel.USERNAME = model.UserProfile.UserProfileName
                            }

                            this.loadPlanList(model.UserProfile.OrgID)
                        },
                        (err) => {
                            this.loadingPDF = false
                        }
                    )
                }
                this.loadingPDF = false
            },
            (error) => {
                this.loadingPDF = false
                console.log(<any>error)
            }
        )
    }

    SavePdf(enrlViewModel: EnrollmentViewModel) {
        //if (enrlViewModel.EOB !== undefined && enrlViewModel.EOB !== null) {
        //    if (enrlViewModel.EOB.toString().toUpperCase() === 'EEOB') {
        //        enrlViewModel.EOB = 'Yes'
        //    } else {
        //        enrlViewModel.EOB = 'No'
        //    }
        //}
        //else {
        //    enrlViewModel.EOB = ''
        //}
        //if (enrlViewModel.EOB !== undefined && enrlViewModel.EOB !== null) {
        //    if (enrlViewModel.EOB.toString().toUpperCase() === '3') {
        //        enrlViewModel.EOB = 'Yes'
        //    } else if (enrlViewModel.EOB.toString().toUpperCase() === 'EEOB'){
        //        enrlViewModel.EOB = 'Yes'
        //    }
        // else {
        //        enrlViewModel.EOB = 'No'
        //    }
        //}
        //else {
        //    enrlViewModel.EOB = ''
        //}

        if (enrlViewModel.PLANYEAR !== undefined && enrlViewModel.PLANYEAR !== '') this.selectedPlanYear = Number(enrlViewModel.PLANYEAR)
        else this.selectedPlanYear = 2021

        this._enrollementGateway
            .generatePDFSearch(this.selectedPlanYear, enrlViewModel, this.currentUser.insuranceCompanyName)
            .subscribe((model: any) => {
                console.log(model)
                var binaryString = window.atob(model)
                var binaryLen = binaryString.length
                console.log('binaryLen' + binaryLen)
                if (binaryLen == 3) {
                    console.log('File doesnt exist / some back ground  error')
                    // this.downloadError = 'File Not Found'
                    return
                }
                //  this.downloadError = ''
                var bytes = new Uint8Array(binaryLen)
                for (var i = 0; i < binaryLen; i++) {
                    var ascii = binaryString.charCodeAt(i)
                    bytes[i] = ascii
                }

                let fileName = enrlViewModel.APPLN + '-' + enrlViewModel.APPFN + '.pdf'
                // below code needed for ie browser
                if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
                    ;(window.navigator as any).msSaveBlob(new Blob([bytes], { type: 'application/pdf' }), fileName)
                }
                // for other browsers
                var fileURL = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }))
                // window.open(fileURL)
                var link = document.createElement('a')
                link.setAttribute('href', fileURL)
                link.setAttribute('download', fileName)
                link.style.display = 'none'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            })
    }

    SaveEnrollment(confNumber: string, apprcvd: boolean) {
        this.enrollmentSearchModel.confirmationNumber = confNumber
        this.enrollmentSearchModel.ApplicationRecievedFlag = apprcvd
        this._reportsGateway.updateEnrollmentStatus(this.enrollmentSearchModel).subscribe(
            (data) => {
                this.saveSuccess = 'Record has been saved successfully!!'
                this.focusableEleTop.nativeElement.focus()
            },
            (err) => {
                this.loading = false
            }
        )
    }

    renderPortalGridRows = (params: any): any[] | null => {
        if (params.data.length > this.fmoModelPortal.PageSize) {
            params.endindex = params.data.length
            params.startindex = params.data.length - this.fmoModelPortal.PageSize
        }
        if (!isNaN(params.startindex)) {
            let filterinfo = this.myGrid.getfilterinformation()
            this.fmoModelPortal.FilterCriteria = this.jqxgridvirtualpaging.onFilter(event, filterinfo)

            this.fmoModelPortal.PageNumber = Math.floor(params.startindex / this.fmoModelPortal.PageSize) + 1
            this.loading = true
            if (!this.skipCallPortal) {
                this.enrollmentSearch = this._reportsGateway.getCustomSearchListSync(this.fmoModelPortal)

                if (this.enrollmentSearch !== undefined && this.enrollmentSearch.length > 0) {
                    this.enrollmentSearch.map(
                        (row) => {
                            row.ApplicationDate = moment(row.ApplicationDate).format('M/D/YYYY')
                            row.EffectiveDate = moment(row.EffectiveDate).format('M/D/YYYY')
                            row.DOB = moment(row.DOB).format('M/D/YYYY')
                            this.loading = false
                        },
                        (err) => {
                            this.loading = false
                        }
                    )
                } else {
                    this.loading = false
                }
            }
        }

        return this.enrollmentSearch
    }

    renderConsumerGridRows = (params: any): any[] => {
        if (params.data.length > this.fmoModelConsumer.PageSize) {
            params.endindex = params.data.length
            params.startindex = params.data.length - this.fmoModelConsumer.PageSize
        }
        if (!isNaN(params.startindex)) {
            let filterinfo = this.myGrid2.getfilterinformation()
            this.fmoModelConsumer.FilterCriteria = this.jqxgridConsumervirtualpaging.onFilter(event, filterinfo)
            this.fmoModelConsumer.PageNumber = Math.floor(params.startindex / this.fmoModelConsumer.PageSize) + 1
            this.loading = true
            if (!this.skipCallConsumer) {
                this.enrollmentConsumerSearch = this._reportsGateway.getConsumerSearchListSync(this.fmoModelConsumer)
                if (this.enrollmentConsumerSearch !== undefined && this.enrollmentConsumerSearch.length > 0) {
                    this.enrollmentConsumerSearch.map(
                        (row) => {
                            row.ApplicationDate = moment(row.ApplicationDate).format('M/D/YYYY')
                            row.EffectiveDate = moment(row.EffectiveDate).format('M/D/YYYY')
                            row.DOB = moment(row.DOB).format('M/D/YYYY')
                            this.loading = false
                        },
                        (err) => {
                            this.loading = false
                        }
                    )
                } else {
                    this.loading = false
                }
            }
        }
        return this.enrollmentConsumerSearch
    }

    renderIPadGridRows = (params: any): any[] => {
        if (params.data.length > this.fmoModelIPad.PageSize) {
            params.endindex = params.data.length
            params.startindex = params.data.length - this.fmoModelIPad.PageSize
        }
        if (!isNaN(params.startindex)) {
            this.fmoModelIPad.PageNumber = Math.floor(params.startindex / this.fmoModelIPad.PageSize) + 1
            this.loading = true
            if (!this.skipCallIPad) {
                this.enrollmentIpadSearch = this._reportsGateway.getIpadSearchListSync(this.fmoModelIPad)
                if (this.enrollmentIpadSearch !== undefined && this.enrollmentIpadSearch.length > 0) {
                    this.enrollmentIpadSearch.map(
                        (row) => {
                            row.ApplicationDate = moment(row.ApplicationDate).format('M/D/YYYY')
                            row.EffectiveDate = moment(row.EffectiveDate).format('M/D/YYYY')
                            if (row.DOB != null && row.DOB != undefined && row.DOB != 'Invalid Date' && row.DOB != '') {
                                row.DOB = moment(row.DOB).format('M/D/YYYY')
                            } else {
                                row.DOB = ''
                            }
                            this.loading = false
                        },
                        (err) => {
                            this.loading = false
                        }
                    )
                } else {
                    this.loading = false
                }
            }
        }
        return this.enrollmentIpadSearch
    }

    onExport(FmoModel: SearchModel, title: string, method: string, totalCount: number) {
        let pageNumber = FmoModel.PageNumber
        let pageSize = totalCount
        this.loadingPDF = true
        let enrollmentData: EnrollmentSearch[] = [] as EnrollmentSearch[]
        // if (totalCount < this.chunkSize) {
        FmoModel.PageNumber = 1
        FmoModel.PageSize = totalCount
        enrollmentData = this.pickGateWayMethod(method, FmoModel, title)

        //} else {
        //    FmoModel.PageSize = this.chunkSize
        //    for (let i = 1; i <= Math.ceil(totalCount / this.chunkSize); i++) {
        //        FmoModel.PageNumber = i
        //        let chunk = this.pickGateWayMethod(method, FmoModel, title)
        //        Array.prototype.push.apply(enrollmentData, chunk)
        //    }
        //}
    }

    pickGateWayMethod(method: string, model: SearchModel, title: string) {
        let data: EnrollmentSearch[] = [] as EnrollmentSearch[]
        let pageNumber = model.PageNumber
        let pageSize = model.PageSize
        switch (method) {
            case 'Portal':
                this._reportsGateway.getCustomSearchList(model).subscribe(
                    (data) => {
                        data = data
                        for (var i = 0; i < data.length; i++) {
                            var row = data[i]
                            if (row.AppRcvd === '0') {
                                row.AppRcvd = ''
                            }
                            if (row.AppRcvd === '1') {
                                row.AppRcvd = 'Recieved'
                            }
                            if (row.SaveRcvd === 2) {
                                row.disable = 'Yes'
                            } else {
                                row.disable = 'No'
                            }
                        }
                        let array = _.clone(data)
                        array.forEach(function (v) {
                            delete v.TotalCount
                            delete v.HIC
                            delete v.EnrollmentKey
                            delete v.PreEnrollmentID
                            delete v.EnrollmentId
                            delete v.LastUpdateTs
                            delete v.LastUpdateUserId
                            delete v.RecCreateTs
                            delete v.RecCreateUserId
                            delete v.SaveRcvd
                            delete v.ApplicationRecievedFlag
                            //delete v.AgentDataSource
                        })

                        if (this._global.currentUser.insuranceCompanyName === this._global.insuranceCompanyNameNEJE) {
                            array.forEach(function (v) {
                                delete v.AppRcvd
                                delete v.disable
                                //delete v.AgentDataSource
                            })
                        }

                        let strArray = JSON.stringify(array)

                        strArray = strArray.replace(/FirstName/g, 'First Name')
                        strArray = strArray.replace(/LastName/g, 'Last Name')
                        strArray = strArray.replace(/AgentID/g, 'Agent ID')
                        strArray = strArray.replace(/DOB/g, 'Date of Birth')
                        strArray = strArray.replace(/HICN/g, 'Medicare Number')
                        strArray = strArray.replace(/confirmationNumber/g, 'Confirmation Number')
                        strArray = strArray.replace(/ApplicationDate/g, 'Application Date')
                        strArray = strArray.replace(/EffectiveDate/g, 'Effective Date')
                        strArray = strArray.replace(/PlanType/g, 'Plan Type')
                        strArray = strArray.replace(/PlanYear/g, 'Plan Year')
                        strArray = strArray.replace(/AppRcvd/g, 'App Rec')
                        strArray = strArray.replace(/disable/g, 'Disabled')
                        strArray = strArray.replace(/DisenrollmentInd/g, 'Is Disenrollment')
                        strArray = strArray.replace(/DisenrollmentDate/g, 'Disenrollment Date')
                        strArray = strArray.replace(/DisenrollmentNoticeDate/g, 'Disenrollment Notice Date')
                        strArray = strArray.replace(/DisenrollmentReasonCode/g, 'Disenrollment Reason Code')
                        strArray = strArray.replace(/DisenrollmentType/g, 'Disenrollment Type')
                        strArray = strArray.replace(/ElectionTypeReasonCode/g, 'Election Type Reason Code')
                        strArray = strArray.replace(/ElectionType/g, 'Election Type')

                        let modEnrollmentData = JSON.parse(strArray)
                        this._excelService.exportAsExcelFile(modEnrollmentData, title)
                        model.PageNumber = pageNumber
                        model.PageSize = pageSize
                        this.loadingPDF = false
                    },
                    (error) => {
                        this.loadingPDF = false
                    }
                )
                break
            case 'Consumer':
                this._reportsGateway.getConsumerSearchList(model).subscribe(
                    (data) => {
                        data = data
                        for (var i = 0; i < data.length; i++) {
                            var row = data[i]
                            if (row.AppRcvd === '0') {
                                row.AppRcvd = ''
                            }
                            if (row.AppRcvd === '1') {
                                row.AppRcvd = 'Recieved'
                            }
                            if (row.SaveRcvd === 2) {
                                row.disable = 'Yes'
                            } else {
                                row.disable = 'No'
                            }
                        }
                        let array = _.clone(data)
                        array.forEach(function (v) {
                            delete v.TotalCount
                            delete v.HIC
                            delete v.EnrollmentKey
                            delete v.PreEnrollmentID
                            delete v.EnrollmentId
                            delete v.LastUpdateTs
                            delete v.LastUpdateUserId
                            delete v.RecCreateTs
                            delete v.RecCreateUserId
                            delete v.SaveRcvd
                            delete v.ApplicationRecievedFlag
                            delete v.AppRcvd
                        })
                        let strArray = JSON.stringify(array)
                        strArray = strArray.replace(/FirstName/g, 'First Name')
                        strArray = strArray.replace(/LastName/g, 'Last Name')
                        strArray = strArray.replace(/AgentID/g, 'Agent ID')
                        strArray = strArray.replace(/DOB/g, 'Date of Birth')
                        strArray = strArray.replace(/HICN/g, 'Medicare Number')
                        strArray = strArray.replace(/confirmationNumber/g, 'Confirmation Number')
                        strArray = strArray.replace(/ApplicationDate/g, 'Application Date')
                        strArray = strArray.replace(/EffectiveDate/g, 'Effective Date')
                        strArray = strArray.replace(/PlanType/g, 'Plan Type')
                        strArray = strArray.replace(/PlanYear/g, 'Plan Year')
                        strArray = strArray.replace(/AppRcvd/g, 'App Rec')
                        strArray = strArray.replace(/disable/g, 'Disabled')
                        strArray = strArray.replace(/ElectionTypeReasonCode/g, 'Election Type Reason Code')
                        strArray = strArray.replace(/ElectionType/g, 'Election Type')

                        let modEnrollmentData = JSON.parse(strArray)
                        this._excelService.exportAsExcelFile(modEnrollmentData, title)
                        model.PageNumber = pageNumber
                        model.PageSize = pageSize
                        this.loadingPDF = false
                    },
                    (error) => {
                        this.loadingPDF = false
                    }
                )
                break
            case 'IPad':
                this._reportsGateway.getIpadSearchList(model).subscribe(
                    (data) => {
                        data = data
                        for (var i = 0; i < data.length; i++) {
                            var row = data[i]
                            if (row.AppRcvd === '0') {
                                row.AppRcvd = ''
                            }
                            if (row.AppRcvd === '1') {
                                row.AppRcvd = 'Recieved'
                            }
                            if (row.SaveRcvd === 2) {
                                row.disable = 'Yes'
                            } else {
                                row.disable = 'No'
                            }
                        }
                        let array = _.clone(data)
                        array.forEach(function (v) {
                            delete v.TotalCount
                            delete v.HIC
                            delete v.EnrollmentKey
                            delete v.PreEnrollmentID
                            delete v.EnrollmentId
                            delete v.LastUpdateTs
                            delete v.LastUpdateUserId
                            delete v.RecCreateTs
                            delete v.RecCreateUserId
                            delete v.SaveRcvd
                            delete v.ApplicationRecievedFlag
                        })
                        let strArray = JSON.stringify(array)
                        strArray = strArray.replace(/FirstName/g, 'First Name')
                        strArray = strArray.replace(/LastName/g, 'Last Name')
                        strArray = strArray.replace(/AgentID/g, 'Agent ID')
                        strArray = strArray.replace(/DOB/g, 'Date of Birth')
                        strArray = strArray.replace(/HICN/g, 'Medicare Number')
                        strArray = strArray.replace(/confirmationNumber/g, 'Confirmation Number')
                        strArray = strArray.replace(/ApplicationDate/g, 'Application Date')
                        strArray = strArray.replace(/EffectiveDate/g, 'Effective Date')
                        strArray = strArray.replace(/PlanType/g, 'Plan Type')
                        strArray = strArray.replace(/PlanYear/g, 'Plan Year')
                        strArray = strArray.replace(/AppRcvd/g, 'App Rec')
                        strArray = strArray.replace(/disable/g, 'Disabled')
                        strArray = strArray.replace(/DisenrollmentInd/g, 'Is Disenrollment')
                        strArray = strArray.replace(/DisenrollmentDate/g, 'Disenrollment Date')
                        strArray = strArray.replace(/DisenrollmentNoticeDate/g, 'Disenrollment Notice Date')
                        strArray = strArray.replace(/DisenrollmentReasonCode/g, 'Disenrollment Reason Code')
                        strArray = strArray.replace(/DisenrollmentType/g, 'Disenrollment Type')
                        let modEnrollmentData = JSON.parse(strArray)
                        this._excelService.exportAsExcelFile(modEnrollmentData, title)
                        model.PageNumber = pageNumber
                        model.PageSize = pageSize
                        this.loadingPDF = false
                    },
                    (error) => {
                        this.loadingPDF = false
                    }
                )
                break
        }

        return data
    }

    onExportPortalEnrollment() {
        this.onExport(this.fmoModelPortal, 'Portal Enrollment', 'Portal', this.totalCountPortal || 0)
        //let pageNumber = this.fmoModelPortal.PageNumber
        //let pageSize = this.fmoModelPortal.PageSize
        //let enrollmentData: EnrollmentSearch[] = [] as EnrollmentSearch[]
        //if (this.totalCount < this.chunkSize) {
        //    this.fmoModelPortal.PageNumber = 1
        //    this.fmoModelPortal.PageSize = this.totalCount
        //    enrollmentData = this._reportsGateway.getCustomSearchListSync(this.fmoModelPortal)
        //} else {
        //    this.fmoModelPortal.PageSize = this.chunkSize
        //    for (let i = 1; i <= Math.ceil(this.totalCount / this.chunkSize); i++) {
        //        this.fmoModelPortal.PageNumber = i
        //        let chunk = this._reportsGateway.getCustomSearchListSync(this.fmoModelPortal)
        //        Array.prototype.push.apply(enrollmentData, chunk)
        //    }
        //}
        //let array = _.clone(enrollmentData)
        //array.forEach(function (v) {
        //    delete v.TotalCount
        //    delete v.HIC
        //    delete v.EnrollmentKey
        //    delete v.PreEnrollmentID
        //    delete v.EnrollmentId
        //    delete v.LastUpdateTs
        //    delete v.LastUpdateUserId
        //    delete v.RecCreateTs
        //    delete v.RecCreateUserId
        //})
        //let strArray = JSON.stringify(array)
        //strArray = strArray.replace(/DateofEnrollment/g, 'Application Date')
        //strArray = strArray.replace(/CoverageEffectiveDate/g, 'Effective Date')
        //strArray = strArray.replace(/AgentUserName/g, 'Agent ID')
        //strArray = strArray.replace(/ApplicantFirstName/g, 'Applicant First Name')
        //strArray = strArray.replace(/ApplicantLastName/g, 'Applicant Last Name')
        //strArray = strArray.replace(/"Name"/g, '"Agent Name"')
        //strArray = strArray.replace(/SubscriberId/g, 'G ID Number')
        //strArray = strArray.replace(/ApplicantHICN/g, 'Medicare Number')
        //strArray = strArray.replace(/TierTranslation/g, 'Plan')
        //strArray = strArray.replace(/Description/g, 'Status')
        //let modEnrollmentData = JSON.parse(strArray)
        //this._excelService.exportAsExcelFile(modEnrollmentData, 'Portal Enrollment')
        //this.fmoModelPortal.PageNumber = pageNumber
        //this.fmoModelPortal.PageSize = pageSize
    }
    onExportConsumerEnrollment() {
        this.onExport(this.fmoModelConsumer, 'Consumer Enrollment', 'Consumer', this.totalCountConsumer || 0)
    }

    onExportIPadEnrollment() {
        this.onExport(this.fmoModelIPad, 'IPad Enrollment', 'IPad', this.totalCountIPad || 0)
    }

    DownloadEnrollmentPDF(EnrollmentId: number) {
        console.log(EnrollmentId)
        this.loadingPDF = true
        this._enrollementGateway.getEnrollmentDetailByEnrollmentID(EnrollmentId).subscribe(
            (response: GetEnrollmentDataByID) => {
                console.log(response)
                if (response !== undefined && response !== null) {
                    if (response.AccountName !== undefined && response.AccountName !== '') {
                        this.enrollmentViewModel.ACCHOLDERNAME = response.AccountName
                    }
                    if (response.CUID !== undefined && response.CUID !== '') {
                        this.enrollmentViewModel.CUID = response.CUID
                    }
                    if (response.ConfirmationNumber !== undefined && response.ConfirmationNumber !== '') {
                        this.enrollmentViewModel.CONF = response.ConfirmationNumber
                    }

                    if (response.ElectionPeriod !== undefined && response.ElectionPeriod !== '') {
                        this.enrollmentViewModel.ELECTION = response.ElectionPeriod
                    }
                    if (response.SecondaryMemberID !== undefined && response.SecondaryMemberID !== '') {
                        this.enrollmentViewModel.SECMBRID = response.SecondaryMemberID
                    }
                    if (response.FamilyID !== undefined && response.FamilyID !== '') {
                        this.enrollmentViewModel.FAMILYID = response.FamilyID
                    }
                    if (response.RelationshipCode !== undefined && response.RelationshipCode != null && response.RelationshipCode !== '') {
                        this.enrollmentViewModel.ISSINGLEGROUP = true

                        this.enrollmentViewModel.RELCD = response.RelationshipCode
                        var relationshipList = [
                            { text: 'Not Specified', value: '00' },
                            { text: 'Employee', value: '01' },
                            { text: 'Spouse', value: '02' },
                            { text: 'Child', value: '03' },
                            { text: 'Other', value: '04' }
                        ]

                        var selectedRelationship = relationshipList.filter((x) => x.value === response.RelationshipCode)[0]
                        if (selectedRelationship !== undefined && selectedRelationship.text !== undefined && selectedRelationship.text !== null) {
                            this.enrollmentViewModel.RELTEXT = selectedRelationship.text
                        } else {
                            this.enrollmentViewModel.RELTEXT = ''
                        }
                    } else {
                        this.enrollmentViewModel.ISSINGLEGROUP = false
                    }

                    if (response.EnrollmentType.toUpperCase() == 'AGNTP' && response.AgentEnrollmentType.toUpperCase() == 'UPLOAD') {
                        this.enrollmentViewModel.ISSINGLEGROUP = false
                    }
                    if (response.PersonCode !== undefined && response.PersonCode !== '') {
                        this.enrollmentViewModel.PERSONCD = response.PersonCode
                        var personCodeList = [
                            { text: 'Card Holder', value: '01' },
                            { text: 'Spouse', value: '02' },
                            { text: 'First Dependent', value: '03' },
                            { text: 'Second Dependent', value: '04' }
                        ]
                        var selectedPersonCode = personCodeList.filter((x) => x.value === response.PersonCode)[0]
                        if (selectedPersonCode !== undefined && selectedPersonCode.text !== undefined && selectedPersonCode.text !== null) {
                            this.enrollmentViewModel.PERSONTEXT = selectedPersonCode.text
                        } else {
                            this.enrollmentViewModel.PERSONTEXT = ''
                        }
                    }
                    if (response.SelectedPlan !== undefined && response.SelectedPlan !== '') {
                        this.enrollmentViewModel.PLANTYPE = response.SelectedPlan
                    }
                    if (response.AgentEnrollmentType !== undefined && response.AgentEnrollmentType !== '') {
                        this.enrollmentViewModel.AGENTDEX = response.AgentEnrollmentType
                    }
                    if (response.ApplicationDate !== undefined && response.ApplicationDate !== '' && response.ApplicationDate !== 'Invalid date') {
                        this.enrollmentViewModel.APPDT = new Date(moment(response.ApplicationDate).format('MM/DD/YYYY'))
                    } else {
                        this.enrollmentViewModel.APPDT = null
                    }

                    if (response.EffectiveDate !== undefined && response.EffectiveDate !== '' && response.EffectiveDate !== 'Invalid date') {
                        this.enrollmentViewModel.EFFDT = new Date(moment(response.EffectiveDate).format('MM/DD/YYYY'))
                    } else {
                        this.enrollmentViewModel.EFFDT = null
                    }

                    if (response.AppliantFirstName !== undefined && response.AppliantFirstName !== '') {
                        this.enrollmentViewModel.APPFN = response.AppliantFirstName
                    }
                    if (response.ApplicantLastName !== undefined && response.ApplicantLastName !== '') {
                        this.enrollmentViewModel.APPLN = response.ApplicantLastName
                    }
                    if (response.Suffix !== undefined && response.Suffix !== '') {
                        this.enrollmentViewModel.SUFFIX = response.Suffix
                    }
                    if (response.ApplicantMiddleInitial !== undefined && response.ApplicantMiddleInitial !== '') {
                        this.enrollmentViewModel.APPMI = response.ApplicantMiddleInitial
                    }
                    if (response.Title !== undefined && response.Title !== '') {
                        this.enrollmentViewModel.TITLE = response.Title
                    }
                    if (response.MedicareNumber !== undefined && response.MedicareNumber !== '') {
                        this.enrollmentViewModel.HICN = response.MedicareNumber
                    }
                    if (
                        response.MedicarePartADate !== undefined &&
                        response.MedicarePartADate !== '' &&
                        response.MedicarePartADate !== 'Invalid date' &&
                        response.MedicarePartADate !== null
                    ) {
                        this.enrollmentViewModel.MEDA = new Date(moment(response.MedicarePartADate).format('MM/DD/YYYY'))
                    } else {
                        this.enrollmentViewModel.MEDA = null
                    }

                    if (
                        response.MedicarePartBDate !== undefined &&
                        response.MedicarePartBDate !== '' &&
                        response.MedicarePartBDate !== 'Invalid date' &&
                        response.MedicarePartBDate !== null
                    ) {
                        this.enrollmentViewModel.MEDB = new Date(moment(response.MedicarePartBDate).format('MM/DD/YYYY'))
                    } else {
                        this.enrollmentViewModel.MEDB = null
                    }

                    if (response.DateOfBirth !== undefined && response.DateOfBirth !== '' && response.DateOfBirth !== 'Invalid date') {
                        this.enrollmentViewModel.APPDOB = new Date(moment(response.DateOfBirth).format('MM/DD/YYYY'))
                    } else {
                        this.enrollmentViewModel.APPDOB = null
                    }

                    if (response.PhoneNumber !== undefined && response.PhoneNumber !== '') {
                        this.enrollmentViewModel.APPPHONE = response.PhoneNumber
                    }
                    if (response.Gender !== undefined && response.Gender !== '') {
                            this.enrollmentViewModel.APPGEN = response.Gender
                    }
                    if (response.CellPhone !== undefined && response.CellPhone !== '') {
                        this.enrollmentViewModel.CELLPHONE = response.CellPhone
                    }
                    if (response.Email !== undefined && response.Email !== '') {
                        this.enrollmentViewModel.APPEMAIL = response.Email
                    }

                    if (response.PermanentAddressLine1 !== undefined && response.PermanentAddressLine1 !== '') {
                        this.enrollmentViewModel.APPADD1 = response.PermanentAddressLine1
                    }
                    if (response.PermanentAddressLine2 !== undefined && response.PermanentAddressLine2 !== '') {
                        this.enrollmentViewModel.APPADD2 = response.PermanentAddressLine2
                    }
                    if (response.PermanentCity !== undefined && response.PermanentCity !== '') {
                        this.enrollmentViewModel.APPCITY = response.PermanentCity
                    }
                    if (response.PermanentZip !== undefined && response.PermanentZip !== '') {
                        this.enrollmentViewModel.APPZIP = response.PermanentZip
                    }
                    if (response.PermanentState !== undefined && response.PermanentState !== '') {
                        this.enrollmentViewModel.APPST = response.PermanentState
                    }
                    if (response.PoverInd !== undefined && response.PoverInd !== '') {
                        this.enrollmentViewModel.POVERIND = response.PoverInd
                    }
                    
                    if (response.LongTermCareFacility !== undefined && response.LongTermCareFacility !== '') {
                        this.enrollmentViewModel.LTCFACILITY = response.LongTermCareFacility
                    }
                    if (response.LongTermCarePhone !== undefined && response.LongTermCarePhone !== '') {
                        this.enrollmentViewModel.LTCPHONE = response.LongTermCarePhone
                    }
                    if (response.Notes !== undefined && response.Notes !== '') {
                        this.enrollmentViewModel.NOTES = response.Notes
                    }
                    if (response.EnrollmentCriteria !== undefined && response.EnrollmentCriteria !== '') {
                        this.enrollmentViewModel.SEPREASONCD = Number(response.EnrollmentCriteria)
                    }

                    if (response.MailingAddressLine1 !== undefined && response.MailingAddressLine1 !== '') {
                        this.enrollmentViewModel.MAILADD1 = response.MailingAddressLine1
                    }
                    if (response.MailingAddressLine2 !== undefined && response.MailingAddressLine2 !== '') {
                        this.enrollmentViewModel.MAILADD2 = response.MailingAddressLine2
                    }
                    if (response.MailingCity !== undefined && response.MailingCity !== '') {
                        this.enrollmentViewModel.MAILCITY = response.MailingCity
                    }
                    if (response.MailingState !== undefined && response.MailingState !== '') {
                        this.enrollmentViewModel.MAILST = response.MailingState
                    }
                    if (response.MailingZipCode !== undefined && response.MailingZipCode !== '') {
                        this.enrollmentViewModel.MAILZIP = response.MailingZipCode
                    }
                    if (response.PremiumPaymentType !== undefined && response.PremiumPaymentType !== '') {
                        this.enrollmentViewModel.PWO = response.PremiumPaymentType
                    }
                    if (response.AgentID !== undefined && response.AgentID !== '') {
                        this.enrollmentViewModel.AGENTID = response.AgentID
                    }

                    if (response.DataEntryID !== undefined && response.DataEntryID !== '') {
                        this.enrollmentViewModel.ADMINID = Number(response.DataEntryID)
                    } else {
                        this.enrollmentViewModel.ADMINID = 0
                    }

                    if (response.PlanYear !== undefined && response.PlanYear !== '') {
                        this.enrollmentViewModel.PLANYEAR = response.PlanYear
                    }
                    if (response.LanguagePreference !== undefined && response.LanguagePreference !== '') {
                        this.enrollmentViewModel.LANG = response.LanguagePreference
                    }
                    //if (response.OtherCoverageEffectiveDate !== undefined && response.LanguagePreference !== '') {
                    //    this.enrollmentViewModel.OTHCVRG = model[i].FieldValue
                    //}
                    if (response.LanguagePrintFormatCode !== undefined && response.LanguagePrintFormatCode !== '') {
                        this.enrollmentViewModel.EOB = response.LanguagePrintFormatCode
                    }
                    if (response.EnrolleeWorkStatus !== undefined && response.EnrolleeWorkStatus !== '') {
                        this.enrollmentViewModel.ENROLLEEWORKSTATUS = response.EnrolleeWorkStatus
                    }
                    if (response.SpouseWorkStatus !== undefined && response.SpouseWorkStatus !== '') {
                        this.enrollmentViewModel.SPOUSEWORKSTATUS = response.SpouseWorkStatus
                    }
                    if (response.AccountNumber !== undefined && response.AccountNumber !== '') {
                        this.enrollmentViewModel.ACCOUNTNB = response.AccountNumber
                    }
                    if (response.OtherCoverageName !== undefined && response.OtherCoverageName !== '') {
                        this.enrollmentViewModel.OTHCVRGNAME = response.OtherCoverageName
                    }
                    if (response.OtherCoverageID !== undefined && response.OtherCoverageID !== '') {
                        this.enrollmentViewModel.OTHCVRGID = response.OtherCoverageID
                    }
                    if (response.OtherCoverageGroup !== undefined && response.OtherCoverageGroup !== '') {
                        this.enrollmentViewModel.OTHCVRGGRP = response.OtherCoverageGroup
                    }
                    if (response.OtherCoverageRxBIN !== undefined && response.OtherCoverageRxBIN !== '') {
                        this.enrollmentViewModel.COBBIN = response.OtherCoverageRxBIN
                    }
                    if (response.OtherCoverageRxPCN !== undefined && response.OtherCoverageRxPCN !== '') {
                        this.enrollmentViewModel.COBPCN = response.OtherCoverageRxPCN
                    }
                    if (
                        response.OtherCoverageEffectiveDate !== undefined &&
                        response.OtherCoverageEffectiveDate !== '' &&
                        response.OtherCoverageEffectiveDate !== 'Invalid date' &&
                        response.OtherCoverageEffectiveDate !== null
                    ) {
                        this.enrollmentViewModel.COBEFFDT = new Date(moment(response.OtherCoverageEffectiveDate).format('MM/DD/YYYY'))
                    } else {
                        this.enrollmentViewModel.COBEFFDT = null
                    }

                    if (
                        response.OtherCoverageTerminationDate !== undefined &&
                        response.OtherCoverageTerminationDate !== '' &&
                        response.OtherCoverageTerminationDate !== 'Invalid date' &&
                        response.OtherCoverageTerminationDate !== null
                    ) {
                        this.enrollmentViewModel.COBTERMDT = new Date(moment(response.OtherCoverageTerminationDate).format('MM/DD/YYYY'))
                    } else {
                        this.enrollmentViewModel.COBTERMDT = null
                    }

                    if (response.FinancialInstitution !== undefined && response.FinancialInstitution !== '') {
                        this.enrollmentViewModel.FININSTNAME = response.FinancialInstitution
                    }
                    if (response.AccountType !== undefined && response.AccountType !== '') {
                        this.enrollmentViewModel.EFTTYPE = response.AccountType
                    }
                    if (response.RoutingNumer !== undefined && response.RoutingNumer !== '') {
                        this.enrollmentViewModel.ROUTINGNB = response.RoutingNumer
                    }
                    if (
                        response.SEFEffectiveDate !== undefined &&
                        response.SEFEffectiveDate !== '' &&
                        response.SEFEffectiveDate !== 'Invalid date' &&
                        response.SEFEffectiveDate !== null
                    ) {
                        this.enrollmentViewModel.SEPEFFDT = new Date(moment(response.SEFEffectiveDate).format('MM/DD/YYYY'))
                    } else {
                        this.enrollmentViewModel.SEPEFFDT = null
                    }
                    if (
                        response.PrimaryCarrier !== undefined &&
                        response.PrimaryCarrier !== '' &&
                        response.PrimaryCarrier !== null &&
                        response.PrimaryAccount !== undefined &&
                        response.PrimaryAccount !== '' &&
                        response.PrimaryAccount !== null &&
                        response.PrimaryGroup !== undefined &&
                        response.PrimaryGroup !== '' &&
                        response.PrimaryGroup !== null
                    ) {
                        this.enrollmentViewModel.ISSTCOB = false
                        this.enrollmentViewModel.CARRIER = response.PrimaryCarrier
                        this.enrollmentViewModel.ACCOUNT = response.PrimaryAccount
                        this.enrollmentViewModel.GROUP = response.PrimaryGroup
                    } else {
                        if (
                            response.SecondaryCarrier !== undefined &&
                            response.SecondaryCarrier !== '' &&
                            response.SecondaryCarrier !== null &&
                            response.SecondaryAccount !== undefined &&
                            response.SecondaryAccount !== '' &&
                            response.SecondaryAccount !== null &&
                            response.SecondaryGroup !== undefined &&
                            response.SecondaryGroup !== '' &&
                            response.SecondaryGroup !== null
                        ) {
                            this.enrollmentViewModel.ISSTCOB = true
                            this.enrollmentViewModel.CARRIER = response.SecondaryCarrier
                            this.enrollmentViewModel.ACCOUNT = response.SecondaryAccount
                            this.enrollmentViewModel.GROUP = response.SecondaryGroup
                        }
                    }
                    if (response.ConfirmationNumber) {
                        if (
                            response.ConfirmationNumber.substring(0, 2).toLowerCase() == 'ic' &&
                            (response.PrimaryCarrier === '' || response.PrimaryCarrier === null) &&
                            (response.PrimaryAccount === '' || response.PrimaryAccount === null) &&
                            (response.PrimaryGroup === '' || response.PrimaryGroup === null)
                        ) {
                            this.enrollmentViewModel.ISSTCOB = false
                            this.enrollmentViewModel.CARRIER = ''
                            this.enrollmentViewModel.ACCOUNT = ''
                            this.enrollmentViewModel.GROUP = ''
                        }
                    }

                    if (response.CareQualifier !== undefined && response.CareQualifier !== '' && response.CareQualifier !== null) {
                        this.enrollmentViewModel.CAREQUAL = response.CareQualifier
                    } else this.enrollmentViewModel.CAREQUAL = ''

                    if (response.CareFacility !== undefined && response.CareFacility !== '' && response.CareFacility !== null) {
                        this.enrollmentViewModel.CAREFAC = response.CareFacility
                    } else this.enrollmentViewModel.CAREFAC = ''

                    if (response.ExternalId !== undefined && response.ExternalId !== '' && response.ExternalId !== null) {
                        this.enrollmentViewModel.EXTERNALID = response.ExternalId
                    } else this.enrollmentViewModel.EXTERNALID = ''

                    //Added the Auth rep details for Ticket #188, (07-05-2019) in SSI and NEJE both.
                    if (
                        response.AuthorizedRepresentativeName !== undefined &&
                        response.AuthorizedRepresentativeName !== '' &&
                        response.AuthorizedRepresentativeName !== null
                    ) {
                        this.enrollmentViewModel.AUTHREPNAME = response.AuthorizedRepresentativeName
                    } else this.enrollmentViewModel.AUTHREPNAME = ''

                    if (
                        response.AuthorizedRepresentativePhone !== undefined &&
                        response.AuthorizedRepresentativePhone !== '' &&
                        response.AuthorizedRepresentativePhone !== null
                    ) {
                        this.enrollmentViewModel.AUTHREPPHONE = response.AuthorizedRepresentativePhone
                    } else this.enrollmentViewModel.AUTHREPPHONE = ''

                    if (
                        response.AuthorizedRepresentativeRelationship !== undefined &&
                        response.AuthorizedRepresentativeRelationship !== '' &&
                        response.AuthorizedRepresentativeRelationship !== null
                    ) {
                        this.enrollmentViewModel.AUTHREPREL = response.AuthorizedRepresentativeRelationship
                    } else this.enrollmentViewModel.AUTHREPREL = ''

                    if (
                        response.AuthorizedRepresentativeAddressLine1 !== undefined &&
                        response.AuthorizedRepresentativeAddressLine1 !== '' &&
                        response.AuthorizedRepresentativeAddressLine1 !== null
                    ) {
                        this.enrollmentViewModel.AUTHREPADD1 = response.AuthorizedRepresentativeAddressLine1
                    } else this.enrollmentViewModel.AUTHREPADD1 = ''

                    if (
                        response.AuthorizedRepresentativeAddressLine2 !== undefined &&
                        response.AuthorizedRepresentativeAddressLine2 !== '' &&
                        response.AuthorizedRepresentativeAddressLine2 !== null
                    ) {
                        this.enrollmentViewModel.AUTHREPADD2 = response.AuthorizedRepresentativeAddressLine2
                    } else this.enrollmentViewModel.AUTHREPADD2 = ''

                    if (
                        response.AuthorizedRepresentativeCity !== undefined &&
                        response.AuthorizedRepresentativeCity !== '' &&
                        response.AuthorizedRepresentativeCity !== null
                    ) {
                        this.enrollmentViewModel.AUTHREPCITY = response.AuthorizedRepresentativeCity
                    } else this.enrollmentViewModel.AUTHREPCITY = ''

                    if (
                        response.AuthorizedRepresentativeState !== undefined &&
                        response.AuthorizedRepresentativeState !== '' &&
                        response.AuthorizedRepresentativeState !== null
                    ) {
                        this.enrollmentViewModel.AUTHREPST = response.AuthorizedRepresentativeState
                    } else this.enrollmentViewModel.AUTHREPST = ''

                    if (
                        response.AuthorizedRepresentativeZipCode !== undefined &&
                        response.AuthorizedRepresentativeZipCode !== '' &&
                        response.AuthorizedRepresentativeZipCode !== null
                    ) {
                        this.enrollmentViewModel.AUTHREPZIP = response.AuthorizedRepresentativeZipCode
                    } else this.enrollmentViewModel.AUTHREPZIP = ''

                    if (response.DisenrollmentInd !== undefined && response.DisenrollmentInd !== null) {
                        if (response.DisenrollmentInd.toLowerCase() === 'false' || response.DisenrollmentInd.toLowerCase() === 'n')
                            this.enrollmentViewModel.DISENROLLIND = 'No'
                        else if (response.DisenrollmentInd.toLowerCase() === 'true' || response.DisenrollmentInd.toLowerCase() === 'y')
                            this.enrollmentViewModel.DISENROLLIND = 'Yes'
                        else this.enrollmentViewModel.DISENROLLIND = response.DisenrollmentInd
                    } else {
                        this.enrollmentViewModel.DISENROLLIND = ''
                    }
                    if (
                        response.DisenrollmentDate !== undefined &&
                        response.DisenrollmentDate !== '' &&
                        response.DisenrollmentDate !== 'Invalid date' &&
                        response.DisenrollmentDate !== null
                    ) {
                        this.enrollmentViewModel.DISENROLLDATE = new Date(moment(response.DisenrollmentDate).format('MM/DD/YYYY')).toString()
                    } else {
                        this.enrollmentViewModel.DISENROLLDATE = ''
                    }
                    if (
                        response.DisenrollmentNoticeDate !== undefined &&
                        response.DisenrollmentNoticeDate !== '' &&
                        response.DisenrollmentNoticeDate !== 'Invalid date' &&
                        response.DisenrollmentNoticeDate !== null
                    ) {
                        this.enrollmentViewModel.DISENROLLNOTICEDT = new Date(
                            moment(response.DisenrollmentNoticeDate).format('MM/DD/YYYY')
                        ).toString()
                    } else {
                        this.enrollmentViewModel.DISENROLLNOTICEDT = ''
                    }
                    if (
                        response.DisenrollmentReasonCode !== undefined &&
                        response.DisenrollmentReasonCode !== '' &&
                        response.DisenrollmentReasonCode !== null
                    ) {
                        this.enrollmentViewModel.DISENROLLREASONCD = response.DisenrollmentReasonCode
                    } else {
                        this.enrollmentViewModel.DISENROLLREASONCD = ''
                    }
                    if (response.DisenrollmentType !== undefined && response.DisenrollmentType !== '' && response.DisenrollmentType !== null) {
                        this.enrollmentViewModel.DISENROLLTYPE = response.DisenrollmentType
                    } else {
                        this.enrollmentViewModel.DISENROLLTYPE = ''
                    }

                    if (response.Race !== undefined && response.Race !== '' && response.Race !== null) {
                        this.enrollmentViewModel.displayRace = response.Race
                    } else {
                        this.enrollmentViewModel.displayRace = ''
                    }
                    if (response.Ethnicity !== undefined && response.Ethnicity !== '' && response.Ethnicity !== null) {
                        this.enrollmentViewModel.displayEthnicity = response.Ethnicity
                    } else {
                        this.enrollmentViewModel.displayEthnicity = ''
                    }

                    if (response.GenderIdentity !== undefined && response.GenderIdentity !== '') {
                        this.enrollmentViewModel.displayCurrentGender = response.GenderIdentity
                    }
                    if (response.DifferentGenderIdentity !== undefined && response.DifferentGenderIdentity !== '') {
                        this.enrollmentViewModel.CURRENTGENDEROTH = response.DifferentGenderIdentity
                    }
                    if (response.SelfIdentity !== undefined && response.SelfIdentity !== '') {
                        this.enrollmentViewModel.displayGenderProNoun = response.SelfIdentity
                    }

                    if (response.DifferentSelfIdentity !== undefined && response.DifferentSelfIdentity !== '') {
                        this.enrollmentViewModel.GENDERNPRONOUNOTH = response.DifferentSelfIdentity
                    }

                    if (response.IndividualRepName !== undefined && response.IndividualRepName !== '') {
                        this.enrollmentViewModel.INDREPNAME = response.IndividualRepName
                    }
                    if (response.RelationshipToEnrollee !== undefined && response.RelationshipToEnrollee !== '') {
                        this.enrollmentViewModel.displayRELTOENROLL = response.RelationshipToEnrollee
                    }

                    if (response.NPN !== undefined && response.NPN !== '') {
                        this.enrollmentViewModel.NPN = response.NPN
                    }

                    this.GetElectionCriteria()
                    this.loadingPDF = false
                } else {
                    this.loadingPDF = false
                    console.log('Enrollment Data not found for Enrollment Key: ' + EnrollmentId)
                }
            },
            (err) => {
                this.loadingPDF = false
            }
        )
    }

    onKeyDown(event, ListValueId: string, Status: string, LeadTypeValue: string) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            //var listValueId = document.getElementById('ListValueId');
            //var status = document.getElementById('Status');
            //var leadTypeValue = document.getElementById('LeadTypeValue');
            this.SearchEnrollment(ListValueId, Status, LeadTypeValue)
        }
    }
    OnRowClick(event: any): void | boolean {
        if (event.args.rightclick) {
            this.gridObj = event.owner
            this.eventObj = event
        }
    }
}
